import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
export const periodCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  id: "period",
  header: "Report period",
  // Sorted on the ISO date, not the rendered label: "Dec 01" sorts before
  // "Feb 01" alphabetically.
  accessorFn: (row) => row.start_date,
  meta: { size: "220px" },
  cell: ({ row }) => (
    <Stack gap="none">
      <span className="font-medium">{row.original.display.period}</span>
      <span className="text-xs text-tertiary-text">
        {row.original.display.span}
      </span>
    </Stack>
  ),
};
